// extracted by mini-css-extract-plugin
export default {"productListCard":"XmlTables_productListCard__5wS6q","table":"XmlTables_table__NtoR4"};